"use strict";module.exports=function(array,value){return-1!==array.indexOf(value)};
